import { APP_PRODUCT_TYPE } from './applicationType';

export const ACCOUNT_REPRESENTATIVES_LIMIT = 400;
export const LOCAL_KEY_ACCOUNT_REP = 'defaultAccountRep';
export const LOCAL_KEY_ACCOUNT_REP_CROP = `${LOCAL_KEY_ACCOUNT_REP}${APP_PRODUCT_TYPE.CROP}`;
export const LOCAL_KEY_ACCOUNT_REP_SEED = `${LOCAL_KEY_ACCOUNT_REP}${APP_PRODUCT_TYPE.SEED}`;
export const ACCOUNT_REPRESENTATIVES_DEFAULT_VALUES = {
  representativeCode: '',
  representativeEmail: '',
  representativeName: '',
};
